import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import componentBase from '../../../src/lib/component-base';

@componentBase('ResponsiveTable')
export default class ResponsiveTable extends React.Component {
  static propTypes = {
    header: PropTypes.array,
    rows: PropTypes.array,
  };

  static defaultProps = {
    header: [],
    rows: [],
  };

  getHeaderColumn = ({ title, titleAlt, style }, i) => {
    const primaryClassNames = ['flights-list-header-text'];
    const secondaryClassNames = ['flights-list-header-text'];

    if (titleAlt) {
      primaryClassNames.push('hidden-xs');
      secondaryClassNames.push('visible-xs');
    }

    if (i === 0) {
      primaryClassNames.push('leftText');
    }

    return (
      <div className={(this.props.rows && this.props.rows[0] && this.props.rows[0][i] && this.props.rows[0][i].primary.className) || `col-xs-${this.columnWidth}`} key={`header-column-${i}`}>
        <p className={primaryClassNames.join(' ')} style={style || { marginLeft: '5px' }}>{title}</p>
        {titleAlt ? <p className={secondaryClassNames.join(' ')} style={style || { marginLeft: '5px' }}>{titleAlt}</p> : null}
      </div>
    );
  };

  getBodyRow = (items, i) => {
    const dv = (
      <div className='multi-flights-list-row row' key={`body-row-${i}-${items[0] && items[0].href}`}>
        <div className='row'>
          {items.map(({ primary }, j) => this.getBodyCell(primary, i, j))}
        </div>
        <div className='row'>
          {items.filter(item => item.secondary).map(({ secondary }, j) => this.getBodyCell(secondary, i, j))}
        </div>
      </div>
    );
    return items[0].href ? <Link
      className='list-card'
      to={items[0].href}
      key={items[0].href}
      onClick={items[0].onClick}
    >{dv}
    </Link> : dv;
  };

  getBodyCell = ({ element, elementAlt, className }, i, j) => <div key={`body-cell-${i}-${j}`} className={`table-cell ${className || `col-xs-${this.columnWidth}`}`}>{element}{elementAlt}</div>;

  get tableHeader() {
    if (!this.props.header || !this.props.header[0]) return null;

    return (
      <div className='multi-flights-list-header row' style={{ paddingTop: '5px' }}>
        {this.props.header.map(this.getHeaderColumn)}
      </div>
    );
  }

  get columns() {
    return (this.props.header && this.props.header.length) ? this.props.header.length : 0;
  }

  get columnWidth() {
    return Math.floor(12 / this.columns);
  }

  get tableRows() {
    return this.props.rows.map(this.getBodyRow);
  }

  render() {
    return (
      <div className='multi-flights-list container'>
        {this.tableHeader}
        {this.tableRows}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/ResponsiveTable/ResponsiveTable.js